import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mr-3 v-theme--light" }
const _hoisted_2 = { class: "row mb-2 py-0" }
const _hoisted_3 = {
  key: 0,
  class: "col"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 1,
  class: "col"
}
const _hoisted_6 = {
  key: 0,
  class: "row mb-2 py-0"
}
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 1,
  class: "row mb-2 py-0"
}
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }

import { ref, computed, watch } from 'vue';
import i18n from '@/lang/i18n';

const errorKeyPrefix = 'initial_params.record';

// Select options

export default /*@__PURE__*/_defineComponent({
  __name: 'Record4ChSetting',
  props: {
    modelValue: {},
    formInputs: {},
    selectDefault: { type: Boolean, default: false },
    isOperationOffice: { type: Boolean, default: false },
    isInstallationOffice: { type: Boolean, default: false },
    errors: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Reactive data
const readonlyInputs = ref<string[]>([]);
const selectCameraPixel = [
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelFHD'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelHD'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelSD360'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectPixelSD480'),
];

const selectCameraOn = [
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectCameraOnOn'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectCameraOnOff')
];

const selectCameraBitrate = [
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectBitrateHigh'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectBitrateMeddle'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectBitrateLow'),
];

const selectCameraHorizon = [
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectHorizonNormal'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectHorizonMirror'),
];

const selectCameraVertical = [
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectVerticalNormal'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectVerticalRotate'),
];

const selectFps = [
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps5'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps10'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps15'),
  i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectFps30'),
];

// Computed properties
const form = computed({
  get() {
    return props.modelValue || {};
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

// Watchers
watch(() => props.formInputs, () => {
  if (!props.formInputs?.form?.record) {
    return;
  }
  const key = Object.keys(props.formInputs.default_params)[0];
  readonlyInputs.value = Object.keys(
    props.formInputs.default_params[key]?.parameters?.record ?? []
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "fs-6 fw-bold mt-4 mb-4 opacity-75" }, "4CH", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!__props.isOperationOffice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_select, {
              "hide-details": "auto",
              class: "small mt-2",
              label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.record.cameraSideOn'),
              modelValue: form.value.cams_on,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.cams_on) = $event)),
              items: selectCameraOn,
              clearable: false,
              disabled: (__props.selectDefault && readonlyInputs.value.includes('cams_on')),
              "error-messages": __props.errors[errorKeyPrefix + '.cams_on']
            }, null, 8, ["label", "modelValue", "disabled", "error-messages"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_select, {
          "hide-details": "auto",
          class: "small mt-2",
          label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.record.cameraSidePixel'),
          modelValue: form.value.cams_pixel,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.cams_pixel) = $event)),
          items: selectCameraPixel,
          clearable: false,
          disabled: (__props.selectDefault && readonlyInputs.value.includes('cams_pixel')) || __props.isInstallationOffice,
          "error-messages": __props.errors[errorKeyPrefix + '.cams_pixel']
        }, null, 8, ["label", "modelValue", "disabled", "error-messages"])
      ]),
      (__props.isOperationOffice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    (!__props.isOperationOffice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_select, {
              "hide-details": "auto",
              class: "small mt-2",
              label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.record.cameraSideBitrate'),
              modelValue: form.value.cams_bitrate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.cams_bitrate) = $event)),
              items: selectCameraBitrate,
              clearable: false,
              disabled: (__props.selectDefault && readonlyInputs.value.includes('cams_bitrate')) || __props.isInstallationOffice,
              "error-messages": __props.errors[errorKeyPrefix + '.cams_bitrate']
            }, null, 8, ["label", "modelValue", "disabled", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_select, {
              "hide-details": "auto",
              class: "small mt-2",
              label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.record.cameraSideHorizon'),
              modelValue: form.value.cams_h,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.cams_h) = $event)),
              items: selectCameraHorizon,
              clearable: false,
              disabled: (__props.selectDefault && readonlyInputs.value.includes('cams_h')) || __props.isInstallationOffice,
              "error-messages": __props.errors[errorKeyPrefix + '.cams_h']
            }, null, 8, ["label", "modelValue", "disabled", "error-messages"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.isOperationOffice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_select, {
              "hide-details": "auto",
              class: "small mt-2",
              label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.record.cameraSideFps'),
              modelValue: form.value.cams_fps,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.cams_fps) = $event)),
              items: selectFps,
              clearable: false,
              disabled: (__props.selectDefault && readonlyInputs.value.includes('cams_fps')) || __props.isInstallationOffice,
              "error-messages": __props.errors[errorKeyPrefix + '.cams_fps']
            }, null, 8, ["label", "modelValue", "disabled", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_select, {
              "hide-details": "auto",
              class: "small mt-2",
              label: _unref(i18n).global.t('pages.vehicles.form.iniFileSetting.record.cameraSideVertical'),
              modelValue: form.value.cams_v,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.cams_v) = $event)),
              items: selectCameraVertical,
              clearable: false,
              disabled: (__props.selectDefault && readonlyInputs.value.includes('cams_v')) || __props.isInstallationOffice,
              "error-messages": __props.errors[errorKeyPrefix + '.cams_v']
            }, null, 8, ["label", "modelValue", "disabled", "error-messages"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})